import React from "react";
import Helmet from "react-helmet";
import { Link } from "@reach/router";

import Navigation from "../../components/WaveNavigation";
import FareTable from "../../components/FareTable";

import FreightRestrictions from "../../components/FreightRestrictions";
import Limitations from "../../components/Limitations";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Ferry Fares"
      meta={[
        { name: "description", content: "Fire Island Ferries Fares" },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h2>Info</h2>
            <h1>Fire Island Ferries Fares</h1>
          </div>
          <p>
            Fire Island Ferries offers several fare options for travel between
            Bay Shore, NY and the eight Fire Island communities we service
            (Kismet, Saltaire, Dunewood, Atlantique, Fair Harbor, Ocean Beach,
            Seaview, Ocean Bay Park).
          </p>
          <p>
            <strong>One-Way</strong> tickets are valid for travel in either
            direction to any of the eight communities we service.
          </p>
          <p>
            <strong>Round-Trip</strong> tickets include two one-way tickets and
            are valid for travel in either direction to any of the eight
            communities we service.
          </p>
          <p>
            <strong>40-Trip Book</strong> tickets include 40 one-way tickets and
            are valid for travel in either direction to any of the eight
            communities we service.
          </p>
        </div>
      </div>
      <FareTable />
      <FreightRestrictions />
      <Limitations />
    </div>
  </div>
);
